<template>
	<div class='tax-data-edit'>
		<div class='grid'>

			<div :class='{ "not-match": !isMatch(values["forest_inventory_year"]) }'>
				<span>Год лесоустройства</span>
				<custom-p-select
					v-model='values["forest_inventory_year"].value'
					:options='info_age'
					:optionLabel='null'
					:dataKey='null'
				/>
			</div>

			<div :class='{ "not-match": !isMatch(values["forest_purpose"]) }'>
				<span>Целевое назначение лесов</span>
				<custom-p-select
					v-model='values["forest_purpose"].value'
					:options='info_forest_purpose'
					:loading='catalogsAreLoading'
					:disabled='catalogsAreLoading'
				/>
			</div>

			<div :class='{ "not-match": !isMatch(values["protection_category"]) }'>
				<span>Категория защитных лесов</span>
				<custom-p-select
					v-model='values["protection_category"].value'
					:options='info_protection_category'
					:loading='catalogsAreLoading'
					:disabled='catalogsAreLoading || protectionCategoryBlocked'
				/>
			</div>

			<div :class='{ "not-match": !isMatch(values["ozu"]) }'>
				<span>ОЗУ</span>
				<custom-p-select
					v-model='values["ozu"].value'
					:options='info_ozu'
					:loading='catalogsAreLoading'
					:disabled='catalogsAreLoading'
				/>
			</div>

			<div :class='{ "not-match": !isMatch(values["oopt"]) }'>
				<span>ООПТ</span>
				<custom-p-select
					v-model='values["oopt"].value'
					:options='info_oopt'
					:loading='catalogsAreLoading'
					:disabled='catalogsAreLoading'
				/>
			</div>

			<div :class='{ "not-match": !isMatch(values["s"]) }'>
				<span>Площадь лесотаксационного выдела, га</span>
				<custom-p-input v-model='values["s"].value' type='number'/>
			</div>

			<div :class='{ "not-match": !isMatch(values["bonitet"]) }'>
				<span>Бонитет</span>
				<custom-p-select
					v-model='values["bonitet"].value'
					:options='info_bonitet'
					:loading='catalogsAreLoading'
					:disabled='catalogsAreLoading'
				/>
			</div>

			<div :class='{ "not-match": !isMatch(values["forest_type"]) }'>
				<span>Тип леса</span>
				<custom-p-input v-model='values["forest_type"].value'/>
			</div>

			<div v-if="false" :class='{ "not-match": !isMatch(values["tlu"]) }'>
				<span>ТЛУ</span>
				<custom-p-select 
					v-model='values["tlu"].value'
					:options='info_tlu'
					:loading='catalogsAreLoading'
					:disabled='catalogsAreLoading'
				/>
			</div>

			<div :class='{ "not-match": !isMatch(values["underwood"]) }'>
				<span>Подрост</span>
				<custom-p-input v-model='values["underwood"].value'/>
			</div>

		</div>

		<div class='grid checkbox-block'>
			<div :class='{ "not-match": !isMatch(values["is_artificial"]) }'>

				<custom-p-checkbox v-model='values["is_artificial"].value' label='Насаждение искусственного происхождения'/>

				<div v-if='values["is_artificial"].value' class='planting-year-block' :class='{ "not-match": !isMatch(values["planting_year"]) }'>
					<span>Год посадки</span>
					<custom-p-select
						v-model='values["planting_year"].value'
						:options='info_age'
						:optionLabel='null'
						:dataKey='null'
					/>
				</div>
			</div>
			
			<div :class='{ "not-match": !isMatch(values["is_after_tapping"]) }'>
				<custom-p-checkbox v-model='values["is_after_tapping"].value' label='Насаждение после подсочки'/>
			</div>

			<div :class='{ "not-match": !isMatch(values["is_drained"]) }'>
				<custom-p-checkbox v-model='values["is_drained"].value' label='Осушенное'/>
			</div>
		</div>

		<div class='grid stock-block'>
			<div :class='{ "not-match": !isMatch(values["stock_dead"]) }'>
				<span>Сухостоя (старого), куб.м/выдел</span>
				<custom-p-input v-model='values["stock_dead"].value' type='number'/>
			</div>
			<div :class='{ "not-match": !isMatch(values["stock_open_stand"]) }'>
				<span>Редин, куб.м/выдел</span>
				<custom-p-input v-model='values["stock_open_stand"].value' type='number'/>
			</div>
			<div :class='{ "not-match": !isMatch(values["stock_single_tree"]) }'>
				<span>Единичных деревьев, куб.м/выдел</span>
				<custom-p-input v-model='values["stock_single_tree"].value' type='number'/>
			</div>
			<div :class='{ "not-match": !isMatch(values["stock_felling_debris"]) }'>
				<span>Захламленность общая, куб.м/выдел</span>
				<custom-p-input v-model='values["stock_felling_debris"].value' type='number'/>
			</div>
			<div :class='{ "not-match": !isMatch(values["stock_liquid_debris"]) }'>
				<span>Захламленность ликвида, куб.м/выдел</span>
				<custom-p-input v-model='values["stock_liquid_debris"].value' type='number'/>
			</div>
		</div>

		<div class='grid non-forest-block'>
			<div :class='{ "not-match": !isMatch(values["non_forest_land"]) }'>
				<span>Нелесные земли</span>
				<custom-p-select
					v-model='values["non_forest_land"].value'
					:options='info_non_forest_land'
					:loading='catalogsAreLoading'
					:disabled='catalogsAreLoading || values["unforested_land"].value!= undefined'
				/>
			</div>
			<div :class='{ "not-match": !isMatch(values["unforested_land"]) }'>
				<span>Не покрытые лесной растительностью земли</span>
				<custom-p-select
					v-model='values["unforested_land"].value'
					:options='info_unforested_land'
					:loading='catalogsAreLoading'
					:disabled='catalogsAreLoading || values["non_forest_land"].value!= undefined'
				/>
			</div>

			<div :class='{ "not-match": !isMatch(values["radioactive_zone"]) }'>
				<span>Зона радиоактивного загрязнения</span>
				<custom-p-select
					v-model='values["radioactive_zone"].value'
					:options='info_radioactive_zone'
					:loading='catalogsAreLoading'
					:disabled='catalogsAreLoading'
				/>
			</div>

			<div v-if='values["unforested_land"].value && values["unforested_land"].value.id === "5"' :class='{ "not-match": !isMatch(values["is_new_dead"]) }'>
				<custom-p-checkbox v-model='values["is_new_dead"].value' label='Свежий сухостой'/>
			</div>

		</div>

		<div class='values-btn-row not-match-block' v-if='notMatchingValues.length'>
			<div>
				<button @click='cancel'>Отмена</button>
				<button @click='save'>Сохранить</button>
			</div>
		</div>

	</div>
</template>

<script>
	import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
	import eventBus from '../../api/eventBus.js'
	const info_age = [];
	let currentAge = +(new Date().getFullYear());
	const lastAge = 1700;
	while (currentAge >= lastAge) {
		info_age.push(String(currentAge--));
	}

	export default {
		name: 'TaxDataEdit',
		components: {
		
		},
		data: () => ({
			info_age,

			values: {
				s: {
					field: 's',
					inputType: 'input',
					value: null,
				},
				forest_inventory_year: {
					field: 'forest_inventory_year',
					inputType: 'input',
					value: null,
				},
				forest_type: {
					field: 'forest_type',
					inputType: 'input',
					value: null,
				},
				tlu: {
					field: 'tlu_id',
					inputType: 'select',
					value: null,
					catalog: 'info_tlu'
				},
				forest_purpose: {
					field: 'forest_purpose_id',
					inputType: 'select',
					value: null,
					catalog: 'info_forest_purpose'
				},
				protection_category: {
					field: 'protection_category_id',
					inputType: 'select',
					value: null,
					catalog: 'info_protection_category'
				},
				ozu: {
					field: 'ozu_id',
					inputType: 'select',
					value: null,
					catalog: 'info_ozu'
				},
				oopt: {
					field: 'oopt_id',
					inputType: 'select',
					value: null,
					catalog: 'info_oopt'
				},
				bonitet: {
					field: 'bonitet_id',
					inputType: 'select',
					value: null,
					catalog: 'info_bonitet'
				},
				underwood: {
					field: 'underwood',
					inputType: 'input',
					value: null,
				},
				is_artificial: {
					field: 'is_artificial',
					inputType: 'checkbox',
					value: false,
				},
				is_after_tapping: {
					field: 'is_after_tapping',
					inputType: 'checkbox',
					value: false,
				},
				is_drained: {
					field: 'is_drained',
					inputType: 'checkbox',
					value: false,
				},
				planting_year: {
					field: 'planting_year',
					inputType: 'input',
					value: null,
				},
				/* запас на выделе */
				stock_dead: {
					field: 'stock_dead',
					inputType: 'input',
					value: null,
				},
				stock_open_stand: {
					field: 'stock_open_stand',
					inputType: 'input',
					value: null,
				},
				stock_single_tree: {
					field: 'stock_single_tree',
					inputType: 'input',
					value: null,
				},
				stock_felling_debris: {
					field: 'stock_felling_debris',
					inputType: 'input',
					value: null,
				},
				stock_liquid_debris: {
					field: 'stock_liquid_debris',
					inputType: 'input',
					value: null,
				},
				/* nonforest */
				non_forest_land: {
					field: 'non_forest_land_id',
					inputType: 'select',
					value: null,
					catalog: 'info_non_forest_land'
				},
				unforested_land: {
					field: 'unforested_land_id',
					inputType: 'select',
					value: null,
					catalog: 'info_unforested_land'
				},
				is_new_dead: {
					field: 'is_new_dead',
					inputType: 'checkbox',
					value: false,
				},
				radioactive_zone: {
					field: 'radioactive_zone_id',
					inputType: 'select',
					value: null,
					catalog: 'info_radioactive_zone'
				}
			},

			catalogsAreLoading: false
		}),
		computed: {
			notMatchingValues() {
				const result = [];

				for (const value_name in this.values) {
					if (!this.isMatch(this.values[value_name])) {
						result.push(value_name);
					}
				}

				return result;
			},

			selectedForestPurpose() {
				return this.values.forest_purpose.value;
			},
			protectionCategoryBlocked() {
				const purpose = this.selectedForestPurpose;
				return (!purpose || purpose.id !== '1');
			},

			selectedIsArtificial() {
				return this.values.is_artificial.value;
			},

			...mapState('taxInfo', {
				selectedTax: state => state['selectedTax']
			}),

			...mapState({
				info_tlu: state => state.catalogs['info_tlu'],
				info_forest_purpose: state => state.catalogs['info_forest_purpose'],
				info_protection_category: state => state.catalogs['info_protection_category'],
				info_ozu: state => state.catalogs['info_ozu'],
				info_oopt: state => state.catalogs['info_oopt'],
				info_bonitet: state => state.catalogs['info_bonitet'],
				info_non_forest_land: state => state.catalogs['info_non_forest_land'],
				info_unforested_land: state => state.catalogs['info_unforested_land'],
				info_radioactive_zone: state => state.catalogs['info_radioactive_zone']
			}),

			...mapGetters('taxInfo', [
				'layerList',
				'isDeadForest',
				'isBurntForest',
				'isDeadOrBurntForest',
				'isDeadSuhostoi',
				'getLandTypes'
			]),

			// value_s() {
			// 	return this.values.s.value;
			// },
		},
		watch: {
			// value_s(value_s) {
			// 	this.values.s.value = this.transformNum(value_s);
			// },

			selectedForestPurpose(purpose) {
				if (!purpose || purpose.id !== '1') {
					this.values.protection_category.value = null;
				}
			},

			selectedIsArtificial(is_artificial) {
				if (!is_artificial) {
					this.values.planting_year.value = null;
				}
			}
		},
		methods: {
			// transformNum(num) {
			// 	console.log(num.replace(',', '.'));
			// 	return num.replace(',', '.');
			// },

			save() {
				const valueList = [];
				const typesUnforest = this.getLandTypes.typesUnforest
				const typesNonForest = this.getLandTypes.typesNonforest
				for (const value_name of this.notMatchingValues) {
					const inputTypeIsSelect = this.values[value_name].inputType === 'select';

					const value = this.values[value_name].value;

					const temp = {
						field: this.values[value_name].field,
						value: value ? (inputTypeIsSelect ? value.id : value) : null
					};
					valueList.push(temp);
				}

				/* Проверка на "непокрытые" и "нелесные" */
				const unforested = this.values.unforested_land.value ? this.values.unforested_land.value: null
				const non_forested = this.values.non_forest_land.value ? this.values.non_forest_land.value: null
				
				const typeUnforest = unforested ? typesUnforest.find((e) => {return e.id == unforested.id}): null
				const typeNonforest = non_forested ? typesNonForest.find((e) => {return e.id == non_forested.id}): null
				//const isUnforested = unforested && (unforested.value === '4' || unforested.value === '5') ? true : false;
				//const wasUnforested = unforested && this.isDeadOrBurntForest;
				const isDeadSuhostoiChanged = valueList.find(item => { return item.field === 'is_new_dead' });
				const unForestedChanged = valueList.find(item => { return item.field === 'unforested_land_id' })?.value !== undefined;
				const nonForestedChanged = valueList.find(item => { return item.field === 'non_forest_land_id' })?.value !== undefined;
				if ((unforested || non_forested) && this.layerList.length && !isDeadSuhostoiChanged && (unForestedChanged || nonForestedChanged)) {
					const confirmation = confirm('Это удалит уже добавленные ярусы и породы. Продолжить?');
					if (!confirmation) {
						return;
					}
				}
				eventBus.$emit('stop-add-layer', 'ok')
				this.saveTaxGeneral(valueList).then(res => {
					// return this.updateTax();
				}).then(res => {
					if ((unforested || non_forested) && (unForestedChanged || nonForestedChanged)) { // добавление яруса непокрытых лесом и нелесных земель
						if (unforested?.id == '3') {
							eventBus.$emit('add-layer', 21)
							return this.removeAllLayers().then(res => {
								return this.updateTax();
							})
						} else if (unforested?.id == '1') {
							eventBus.$emit('add-layer', 22)
							return this.removeAllLayers().then(res => {
								return this.updateTax();
							})
						} else if (unforested?.id == '5' && this.values['is_new_dead'].value) {
							console.log('555')
							eventBus.$emit('add-layer', 23)
							return this.removeAllLayers().then(res => {
								return this.updateTax();
							}) 
						} else if (unforested?.id == '5' && isDeadSuhostoiChanged && this.layerList.length) { // обновление яруса погибших
							const comp = typeUnforest ? typeUnforest?.text: typeNonforest ? typeNonforest?.text: null
							const layer = {
								layer_id: this.layerList[0].layer_id,
								composition: this.values['is_new_dead'].value ? `${comp} свежий сухостой` : comp,
								fullness: null,
								stock: null,
								age_class: null,
							};

							return this.editLayer(layer);
					} else {
							return this.removeAllLayers().then(res => {
								return this.updateTax();
									}).then(res => {
										const layer = {
											composition: typeUnforest ? typeUnforest?.text: typeNonforest ? typeNonforest?.text: null,
											fullness: null,
											stock: null,
											age_class: null
										};

										if (unforested?.id == '5' && this.values['is_new_dead'].value) {
											layer.composition += ' свежий сухостой';
										}
										return this.addLayer(layer);
									});
						}
					} else if (this.layerList.length && (unForestedChanged || nonForestedChanged)) {
						console.log('111111')
						return this.removeAllLayers().then(res => {
							//eventBus.$emit('stop-add-layer', 'ok')
							return this.updateTax();
						})
					} else {
						//eventBus.$emit('stop-add-layer', 'ok')
					}

				}).then(res => {
					return this.updateTax();
				}).then(res => {
					return this.resetValues();
				})
			},

			cancel() {
				this.resetValues();
			},

			resetValues(...valueList) {
				for (let value_name in this.values) {
					const value = this.values[value_name];

					if (value.inputType === 'checkbox') {
						value.value = this.selectedTax[0][value.field] === 't';
					} else if (value.inputType === 'select') {

						value.value = this[value.catalog].find(item => {
							return item.id === this.selectedTax[0][value.field];
						});
						// value.value = temp ? temp : null;

					} else if (value.inputType === 'input') {
						value.value = this.selectedTax[0][value.field];
					}
				}

				// console.log(JSON.stringify(this.values, null, 2));
			},

			isMatch(value) {
				if (this.catalogsAreLoading) {
					return true;
				}

				if (value.inputType === 'checkbox') {
					return value.value === (this.selectedTax[0][value.field] === 't');
				} else if (value.inputType === 'select') {
					if (!value.value) {
						return this.selectedTax[0][value.field] === null;
					} else {
						return value.value.id === this.selectedTax[0][value.field];
					}
				} else if (value.inputType === 'input') {
					return value.value === this.selectedTax[0][value.field];
				}

				return false;
			},

			...mapMutations([
				'addEmptyValueForCatalog'
			]),

			...mapActions('taxInfo', [
				'updateTax',
				'saveTaxGeneral',
				'removeAllLayers',
				'addLayer',
				'editLayer'
			]),

			...mapActions([
				'loadCatalogs'
			])
		},
		created() {
			eventBus.$on('stock-single-set', (e) => {
				if (this.values['s'].value > 0) {
					this.values['stock_single_tree'].value = e * this.values['s'].value
				}
      			
    		})
			const catalogs = [
				'info_tlu',
				'info_forest_purpose',
				'info_protection_category',
				'info_ozu',
				'info_oopt',
				'info_bonitet',
				'info_non_forest_land',
				'info_unforested_land',
				'info_radioactive_zone'
			];

			this.catalogsAreLoading = true;
			this.loadCatalogs(catalogs).then(res => {

				this.addEmptyValueForCatalog('info_ozu');
				this.addEmptyValueForCatalog('info_oopt');

				this.resetValues();
				this.catalogsAreLoading = false;
			});
		},
		beforeDestroy() {
    		eventBus.$off('stock-single-set')
  		}
	};
</script>

<style scoped src='@/style/grid.css'></style>
<style scoped src='@/style/button.css'></style>
<style scoped src='@/style/input.css'></style>

<style scoped>
	
	.not-match {
		background-color: orange;
	}

	.checkbox-block {
		margin-top: 2rem;
	}

	.stock-block {
		margin-top: 2rem;
	}

	.planting-year-block {
		margin-top: 0.5rem;
	}

	.non-forest-block {
		margin-top: 2rem;
	}

</style>